import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({ dark: false });

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    window.localStorage.removeItem('hxaro-theme');
  }, []);

  return (
    <ThemeContext.Provider value={{ dark: false }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
